/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_BiologyInputs */

const en_onboarding_genre_biology = /** @type {(inputs: Onboarding_Genre_BiologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biology`)
};

const es_onboarding_genre_biology = /** @type {(inputs: Onboarding_Genre_BiologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biología`)
};

/**
* | output |
* | --- |
* | "Biology" |
*
* @param {Onboarding_Genre_BiologyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_biology = /** @type {((inputs?: Onboarding_Genre_BiologyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_BiologyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_biology(inputs)
	return en_onboarding_genre_biology(inputs)
});